var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g2, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrazilFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3833_12983)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 0.5H0V29.5H42V0.5Z",
    fill: "#009B3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50684 14.9981L21.5117 25.9767L38.5166 14.9981L21.5117 4.01953L4.50684 14.9981Z",
    fill: "#FEDF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5125 22.25C25.4728 22.25 28.6833 19.0041 28.6833 15C28.6833 10.9959 25.4728 7.75 21.5125 7.75C17.5522 7.75 14.3418 10.9959 14.3418 15C14.3418 19.0041 17.5522 22.25 21.5125 22.25Z",
    fill: "#002776"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3833_12983",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 7,
    width: 15,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5125 22.25C25.4728 22.25 28.6833 19.0041 28.6833 15C28.6833 10.9959 25.4728 7.75 21.5125 7.75C17.5522 7.75 14.3418 10.9959 14.3418 15C14.3418 19.0041 17.5522 22.25 21.5125 22.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3833_12983)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 29.5017C0 19.7775 7.79675 11.8945 17.4146 11.8945C27.0325 11.8945 34.8293 19.7775 34.8293 29.5017H33.8049C33.8049 20.3494 26.4668 12.9302 17.4146 12.9302C8.36244 12.9302 1.02439 20.3494 1.02439 29.5017H0Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3963 12.8827C15.5647 12.862 15.6825 12.6917 15.6598 12.5024C15.637 12.313 15.4816 12.1767 15.3132 12.1974C15.1447 12.2181 15.0269 12.3884 15.0497 12.5777C15.0725 12.767 15.2278 12.9034 15.3963 12.8827ZM15.3803 12.7555C15.4794 12.7434 15.5477 12.637 15.5334 12.5179C15.5192 12.3988 15.427 12.3125 15.328 12.3246C15.229 12.3366 15.1607 12.4431 15.1749 12.5622C15.1891 12.6813 15.2813 12.7676 15.3803 12.7555Z",
    fill: "#009B3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9522 12.8196L16.0785 12.8104L16.0609 12.5543L16.3335 12.5353C16.4519 12.5267 16.5406 12.4231 16.5327 12.3035C16.5247 12.1838 16.4217 12.094 16.3033 12.1021L15.9141 12.1297L15.9522 12.819V12.8196ZM16.0524 12.4266L16.3153 12.4082C16.3637 12.4047 16.4001 12.3621 16.3967 12.3132C16.3932 12.2643 16.3511 12.2275 16.3028 12.231L16.0398 12.2494L16.0524 12.4266Z",
    fill: "#009B3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5316 12.7774C16.5247 12.679 16.5099 12.4627 16.3637 12.473L16.1787 12.4862C16.3927 12.4713 16.4081 12.6876 16.4143 12.786",
    fill: "#009B3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8176 12.766L17.1397 12.7603C17.3014 12.7574 17.43 12.6227 17.4271 12.4593L17.4254 12.3609C17.4226 12.1975 17.2894 12.0675 17.1278 12.0704L16.8057 12.0761L16.8176 12.7666V12.766ZM16.9422 12.6354L17.1278 12.6319C17.2302 12.6302 17.3116 12.5451 17.3099 12.4415L17.3088 12.3822C17.307 12.2787 17.2228 12.1964 17.1204 12.1981L16.9349 12.2015L16.9422 12.6354Z",
    fill: "#009B3A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6851 12.7569L18.2992 12.7787L18.3038 12.6504L17.8064 12.6326L17.8126 12.4554L18.2025 12.4692L18.2064 12.3507L17.8166 12.3368L17.8212 12.1987L18.289 12.2154L18.2935 12.0871L17.7085 12.0664L17.6846 12.7563L17.6851 12.7569Z",
    fill: "#009B3A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5518 12.7931L18.6684 12.8034L18.7094 12.3316L18.8044 12.8155L18.9114 12.8247L19.0884 12.365L19.0474 12.8368L19.1641 12.8472L19.2239 12.1596L19.0537 12.1446L18.8767 12.6043L18.7817 12.1204L18.6115 12.1055L18.5518 12.7931Z",
    fill: "#009B3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9668 12.9571L20.4716 13.0446L20.4915 12.9278L20.1022 12.8599L20.1284 12.7045L20.446 12.7598L20.4659 12.643L20.1483 12.5877L20.1666 12.4807L20.5439 12.5463L20.5638 12.4295L20.0709 12.3438L19.9668 12.956V12.9571Z",
    fill: "#009B3A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2637 13.2138L21.3866 13.246L21.4503 12.9974L21.715 13.0665C21.8299 13.0964 21.9466 13.0268 21.9768 12.9105C22.0069 12.7943 21.9375 12.6763 21.8225 12.6458L21.4446 12.5469L21.2642 13.2126L21.2637 13.2138ZM21.4816 12.8731L21.7366 12.9399C21.7833 12.952 21.8316 12.9238 21.8436 12.876C21.8555 12.8282 21.8277 12.7799 21.7804 12.7678L21.5255 12.7011L21.4816 12.8731Z",
    fill: "#009B3A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1016 13.4405L22.2228 13.4791L22.299 13.2345L22.5597 13.3174C22.6729 13.3536 22.793 13.2898 22.8289 13.1759C22.8647 13.0619 22.8016 12.9399 22.6889 12.9037L22.3167 12.7852L22.1021 13.4405H22.1016ZM22.3366 13.1126L22.5876 13.1925C22.6337 13.2075 22.6832 13.1816 22.698 13.1344C22.7128 13.0872 22.6872 13.0378 22.6405 13.0228L22.3895 12.9428L22.3366 13.112V13.1126Z",
    fill: "#009B3A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6551 13.617C22.6847 13.5233 22.749 13.3161 22.6096 13.2712L22.4326 13.2148C22.6375 13.2799 22.5726 13.487 22.5436 13.5814",
    fill: "#009B3A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2139 13.8169C23.3727 13.8767 23.5553 13.7806 23.6214 13.6022C23.6874 13.4239 23.6123 13.23 23.4529 13.1701C23.2936 13.1103 23.1114 13.2064 23.0454 13.3847C22.9794 13.5631 23.0545 13.757 23.2139 13.8169ZM23.2583 13.6966C23.3516 13.7317 23.4609 13.6696 23.5024 13.5574C23.544 13.4452 23.5024 13.3255 23.4085 13.2904C23.3146 13.2553 23.2059 13.3174 23.1644 13.4296C23.1228 13.5418 23.1644 13.6615 23.2583 13.6966Z",
    fill: "#009B3A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3833_12983",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 13,
    width: 2,
    height: 2
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7363 14.0236L24.0089 13.3906L24.5723 13.6386L24.3003 14.2716L23.7369 14.0236H23.7363ZM24.2013 13.7226L24.1546 13.8314L24.4363 13.9551L24.483 13.8463L24.2013 13.7226Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3833_12983)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0187 14.1492C24.1741 14.2177 24.3613 14.1314 24.4365 13.9564C24.5116 13.7815 24.4467 13.5842 24.2908 13.5157C24.1348 13.4472 23.9482 13.5335 23.873 13.7084C23.7979 13.8834 23.8628 14.0807 24.0187 14.1492ZM24.0688 14.0312C24.1604 14.0715 24.2726 14.0151 24.3198 13.9052C24.367 13.7953 24.3312 13.6739 24.2401 13.6336C24.1491 13.5934 24.0364 13.6497 23.9891 13.7596C23.9419 13.8695 23.9778 13.991 24.0688 14.0312Z",
    fill: "#009B3A"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.199 13.8512L24.1602 13.9414L24.3971 14.0456L24.4359 13.9553L24.199 13.8512Z",
    fill: "#009B3A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3471 13.9139L24.2109 14.2305L24.3002 14.2697L24.4363 13.9531L24.3471 13.9139Z",
    fill: "#009B3A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5283 14.3796L24.6416 14.4365L24.7548 14.207L24.9995 14.3301C25.1054 14.3836 25.2346 14.3399 25.2875 14.2328C25.3404 14.1258 25.2972 13.9952 25.1913 13.9417L24.8419 13.7656L24.5283 14.379V14.3796ZM24.8117 14.093L25.0473 14.2121C25.0906 14.234 25.1435 14.2162 25.1651 14.1724C25.1868 14.1287 25.1691 14.0752 25.1259 14.0533L24.8903 13.9342L24.8117 14.093Z",
    fill: "#009B3A"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0477 14.6431C25.091 14.555 25.1871 14.3605 25.0562 14.2944L24.8906 14.2109C25.083 14.3076 24.9868 14.5021 24.9436 14.5901",
    fill: "#009B3A"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3018 14.7771L25.8367 15.0832L25.8993 14.9716L25.4662 14.7236L25.5527 14.5688L25.8925 14.7633L25.95 14.6603L25.6102 14.4658L25.6774 14.3455L26.0848 14.5786L26.1474 14.4669L25.6381 14.1758L25.3018 14.7765V14.7771Z",
    fill: "#009B3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2978 15.1113C26.2614 15.1694 26.2978 15.2344 26.3803 15.2874C26.4628 15.3403 26.5186 15.3386 26.5425 15.3012C26.617 15.1827 26.1851 15.0095 26.3183 14.8029C26.4332 14.6251 26.6296 14.7638 26.7035 14.8109C26.7775 14.8581 26.8965 14.9818 26.8043 15.124L26.6791 15.0434C26.7183 14.9813 26.6751 14.9208 26.6096 14.8788C26.5442 14.8368 26.4941 14.819 26.456 14.8788C26.3922 14.9755 26.8157 15.1573 26.6859 15.3633C26.5903 15.5152 26.4235 15.4491 26.3126 15.3771C26.2181 15.3161 26.0764 15.1723 26.1686 15.0273L26.2983 15.1107L26.2978 15.1113Z",
    fill: "#009B3A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0311 15.6019C26.9912 15.6583 27.0254 15.725 27.1045 15.782C27.1836 15.8389 27.2399 15.8401 27.2655 15.8044C27.3463 15.6899 26.9241 15.4943 27.0675 15.2952C27.1915 15.1237 27.3799 15.2722 27.4516 15.324C27.5233 15.3757 27.6354 15.5052 27.5359 15.6421L27.4146 15.5547C27.4573 15.4943 27.4169 15.4321 27.3537 15.3867C27.2906 15.3412 27.2416 15.3211 27.2001 15.3792C27.1318 15.4718 27.545 15.6761 27.4044 15.8752C27.3008 16.0219 27.1381 15.9465 27.0311 15.8694C26.94 15.8038 26.8057 15.6525 26.9053 15.5121L27.0305 15.6024L27.0311 15.6019Z",
    fill: "#009B3A"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7235 16.3955C27.8561 16.5025 28.0593 16.468 28.1765 16.319C28.2937 16.1699 28.2812 15.9622 28.1486 15.8552C28.016 15.7482 27.8128 15.7827 27.6956 15.9317C27.5784 16.0808 27.5909 16.2885 27.7235 16.3955ZM27.8026 16.2954C27.8806 16.3581 28.0035 16.3328 28.0775 16.239C28.1514 16.1452 28.148 16.018 28.0701 15.9553C27.9921 15.8926 27.8692 15.9179 27.7952 16.0117C27.7212 16.1055 27.7246 16.2327 27.8026 16.2954Z",
    fill: "#009B3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6585 13.3867L15.5635 13.6825L15.7097 13.7302",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6586 13.3867L15.7537 13.6825L15.6074 13.7302",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9509 13.6016H15.6436V13.7569",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9505 13.6016L15.7018 13.784L15.6113 13.6585",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3662 13.6016L15.6149 13.784L15.7054 13.6585",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3662 13.6016H15.6735V13.7569",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8399 13.9481L15.7449 13.6523L15.5986 13.7001",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8395 13.9485L15.5908 13.7661L15.6813 13.6406",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4775 13.9485L15.7262 13.7661L15.6358 13.6406",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4775 13.9481L15.5726 13.6523L15.7188 13.7001",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2923 16.4336L16.1973 16.7293L16.3435 16.7771",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2924 16.4336L16.3875 16.7293L16.2412 16.7771",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5847 16.6484H16.2773V16.8038",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5843 16.6484L16.3356 16.8308L16.2451 16.7054",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.6484L16.2487 16.8308L16.3392 16.7054",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.6484H16.3073V16.8038",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4737 16.995L16.3787 16.6992L16.2324 16.747",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4733 16.9953L16.2246 16.8129L16.3151 16.6875",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1113 16.9953L16.36 16.8129L16.2695 16.6875",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1113 16.995L16.2064 16.6992L16.3526 16.747",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4141 17.1367L15.335 17.383L15.4567 17.4233",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4138 17.1367L15.4929 17.383L15.3711 17.4233",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6584 17.3164H15.4023V17.4459",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6583 17.3164L15.4511 17.4689L15.376 17.3642",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1709 17.3164L15.3781 17.4689L15.4532 17.3642",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1709 17.3164H15.427V17.4459",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5642 17.6056L15.4851 17.3594L15.3633 17.3997",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5646 17.6049L15.3574 17.4524L15.4325 17.3477",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2637 17.6049L15.4708 17.4524L15.3957 17.3477",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2637 17.6056L15.3428 17.3594L15.4646 17.3997",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9952 16.1523L16.9502 16.2933L17.0196 16.3163",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9952 16.1523L17.0401 16.2933L16.9707 16.3163",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1336 16.2539H16.9873V16.3281",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1333 16.2539L17.0149 16.3408L16.9717 16.2809",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8555 16.2539L16.9738 16.3408L17.0171 16.2809",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8555 16.2539H17.0017V16.3281",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0812 16.4183L17.0362 16.2773L16.9668 16.3004",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0813 16.4202L16.9629 16.3333L17.0061 16.2734",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9092 16.4202L17.0276 16.3333L16.9843 16.2734",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9092 16.4183L16.9541 16.2773L17.0236 16.3004",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7852 17.207L17.7061 17.4533L17.8278 17.4936",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7849 17.207L17.864 17.4533L17.7422 17.4936",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0295 17.3867H17.7734V17.5162",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0293 17.3867L17.8222 17.5392L17.7471 17.4345",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17.542 17.3867L17.7491 17.5392L17.8243 17.4345",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M17.542 17.3867H17.7981V17.5162",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9362 17.676L17.8571 17.4297L17.7354 17.47",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9366 17.6752L17.7295 17.5227L17.8046 17.418",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6357 17.6752L17.8429 17.5227L17.7678 17.418",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6357 17.676L17.7148 17.4297L17.8366 17.47",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M17.571 17.9805L17.5078 18.1773L17.6051 18.2095",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5713 17.9805L17.6344 18.1773L17.5371 18.2095",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7664 18.125H17.5615V18.2286",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17.766 18.125L17.6004 18.247L17.54 18.163",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M17.376 18.125L17.5416 18.247L17.6019 18.163",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M17.376 18.125H17.5809V18.2286",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6908 18.353L17.6276 18.1562L17.5303 18.1885",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M17.691 18.3544L17.5254 18.2324L17.5857 18.1484",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4502 18.3544L17.6158 18.2324L17.5555 18.1484",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4502 18.353L17.5134 18.1562L17.6107 18.1885",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7366 12.4414L23.6416 12.7372L23.7879 12.7849",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7368 12.4414L23.8318 12.7372L23.6855 12.7849",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24.029 12.6562H23.7217V12.8116",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0286 12.6562L23.7799 12.8387L23.6895 12.7132",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4443 12.6562L23.693 12.8387L23.7835 12.7132",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4443 12.6562H23.7517V12.8116",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9181 13.0028L23.823 12.707L23.6768 12.7548",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9176 13.0032L23.6689 12.8207L23.7594 12.6953",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5557 13.0032L23.8044 12.8207L23.7139 12.6953",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5557 13.0028L23.6507 12.707L23.797 12.7548",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5364 17.2344L26.4414 17.5301L26.5877 17.5779",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5366 17.2344L26.6316 17.5301L26.4854 17.5779",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8288 17.4492H26.5215V17.6046",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8284 17.4492L26.5797 17.6316L26.4893 17.5062",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 17.4492L26.4928 17.6316L26.5833 17.5062",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 17.4492H26.5515V17.6046",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7179 17.7958L26.6228 17.5L26.4766 17.5478",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7174 17.7961L26.4688 17.6137L26.5592 17.4883",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3555 17.7961L26.6042 17.6137L26.5137 17.4883",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3555 17.7958L26.4505 17.5L26.5968 17.5478",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5319 17.4062L27.4688 17.603L27.5661 17.6353",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5322 17.4062L27.5954 17.603L27.498 17.6353",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7273 17.5508H27.5225V17.6544",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7269 17.5508L27.5613 17.6728L27.501 17.5888",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3369 17.5508L27.5025 17.6728L27.5628 17.5888",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3369 17.5508H27.5418V17.6544",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6517 17.7788L27.5885 17.582L27.4912 17.6143",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6519 17.7802L27.4863 17.6582L27.5467 17.5742",
    fill: "white"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4111 17.7802L27.5767 17.6582L27.5164 17.5742",
    fill: "white"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4111 17.7788L27.4743 17.582L27.5716 17.6143",
    fill: "white"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8291 17.9258L26.75 18.1721L26.8718 18.2123",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8288 17.9258L26.9079 18.1721L26.7861 18.2123",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0735 18.1055H26.8174V18.2349",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0733 18.1055L26.8661 18.2579L26.791 18.1532",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859 18.1055L26.7931 18.2579L26.8682 18.1532",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5859 18.1055H26.842V18.2349",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9792 18.3947L26.9001 18.1484L26.7783 18.1887",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9796 18.3939L26.7725 18.2414L26.8476 18.1367",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6787 18.3939L26.8859 18.2414L26.8107 18.1367",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6787 18.3947L26.7578 18.1484L26.8796 18.1887",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1025 19.4453L25.0234 19.6916L25.1452 19.7319",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1023 19.4453L25.1814 19.6916L25.0596 19.7319",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3469 19.625H25.0908V19.7545",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3467 19.625L25.1396 19.7775L25.0645 19.6728",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8594 19.625L25.0665 19.7775L25.1417 19.6728",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8594 19.625H25.1155V19.7545",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2527 19.9142L25.1735 19.668L25.0518 19.7082",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2531 19.9135L25.0459 19.761L25.121 19.6562",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9521 19.9135L25.1593 19.761L25.0842 19.6562",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9521 19.9142L25.0313 19.668L25.153 19.7082",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0925 20.2266L25.0293 20.4233L25.1266 20.4556",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0927 20.2266L25.1559 20.4233L25.0586 20.4556",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2879 20.3711H25.083V20.4747",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2875 20.3711L25.1218 20.4931L25.0615 20.4091",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8975 20.3711L25.0631 20.4931L25.1234 20.4091",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8975 20.3711H25.1023V20.4747",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2122 20.5991L25.1491 20.4023L25.0518 20.4346",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2125 20.6005L25.0469 20.4785L25.1072 20.3945",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9717 20.6005L25.1373 20.4785L25.077 20.3945",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9717 20.5991L25.0349 20.4023L25.1322 20.4346",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8151 18.9258L25.752 19.1226L25.8493 19.1548",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8154 18.9258L25.8786 19.1226L25.7812 19.1548",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0096 19.0703H25.8047V19.1739",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0091 19.0703L25.8435 19.1923L25.7832 19.1083",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6201 19.0703L25.7857 19.1923L25.8461 19.1083",
    fill: "white"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6201 19.0703H25.825V19.1739",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9349 19.2983L25.8717 19.1016L25.7744 19.1338",
    fill: "white"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9351 19.2997L25.7695 19.1778L25.8299 19.0938",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6943 19.2997L25.8599 19.1778L25.7996 19.0938",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6943 19.2983L25.7575 19.1016L25.8548 19.1338",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3897 18.5078L26.3105 18.7541L26.4323 18.7944",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3894 18.5078L26.4685 18.7541L26.3467 18.7944",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M26.634 18.6875H26.3779V18.817",
    fill: "white"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6338 18.6875L26.4267 18.84L26.3516 18.7353",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1465 18.6875L26.3536 18.84L26.4288 18.7353",
    fill: "white"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1465 18.6875H26.4026V18.817",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5407 18.9767L26.4616 18.7305L26.3398 18.7707",
    fill: "white"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5411 18.976L26.334 18.8235L26.4091 18.7188",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2402 18.976L26.4474 18.8235L26.3723 18.7188",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2402 18.9767L26.3193 18.7305L26.4411 18.7707",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0739 18.7891L25.0107 18.9858L25.1081 19.0181",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0742 18.7891L25.1374 18.9858L25.04 19.0181",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2693 18.9336H25.0645V19.0372",
    fill: "white"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2689 18.9336L25.1033 19.0556L25.043 18.9716",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8789 18.9336L25.0445 19.0556L25.1048 18.9716",
    fill: "white"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8789 18.9336H25.0838V19.0372",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1937 19.1616L25.1305 18.9648L25.0332 18.9971",
    fill: "white"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1939 19.163L25.0283 19.041L25.0886 18.957",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9531 19.163L25.1187 19.041L25.0584 18.957",
    fill: "white"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9531 19.1616L25.0163 18.9648L25.1136 18.9971",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7803 15.0352L18.7012 15.2814L18.823 15.3217",
    fill: "white"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18.78 15.0352L18.8591 15.2814L18.7373 15.3217",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0247 15.2148H18.7686V15.3443",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0245 15.2148L18.8173 15.3673L18.7422 15.2626",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5371 15.2148L18.7443 15.3673L18.8194 15.2626",
    fill: "white"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5371 15.2148H18.7932V15.3443",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9314 15.5041L18.8523 15.2578L18.7305 15.2981",
    fill: "white"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9318 15.5033L18.7246 15.3508L18.7997 15.2461",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6299 15.5033L18.837 15.3508L18.7619 15.2461",
    fill: "white"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6299 15.5041L18.709 15.2578L18.8308 15.2981",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4636 14.4297L23.4004 14.6265L23.4977 14.6587",
    fill: "white"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4638 14.4297L23.527 14.6265L23.4297 14.6587",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M23.659 14.5742H23.4541V14.6778",
    fill: "white"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6586 14.5742L23.4929 14.6962L23.4326 14.6122",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2686 14.5742L23.4342 14.6962L23.4945 14.6122",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2686 14.5742H23.4734V14.6778",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5833 14.8023L23.5202 14.6055L23.4229 14.6377",
    fill: "white"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5836 14.8036L23.418 14.6817L23.4783 14.5977",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3428 14.8036L23.5084 14.6817L23.4481 14.5977",
    fill: "white"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3428 14.8023L23.4059 14.6055L23.5033 14.6377",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M21.512 17.9453L21.417 18.2411L21.5633 18.2888",
    fill: "white"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5122 17.9453L21.6072 18.2411L21.4609 18.2888",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8054 18.1602H21.498V18.3155",
    fill: "white"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M21.805 18.1602L21.5563 18.3426L21.4658 18.2171",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2197 18.1602L21.4684 18.3426L21.5589 18.2171",
    fill: "white"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2197 18.1602H21.527V18.3155",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6935 18.5067L21.5984 18.2109L21.4521 18.2587",
    fill: "white"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M21.693 18.5071L21.4443 18.3247L21.5348 18.1992",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M21.332 18.5071L21.5807 18.3247L21.4902 18.1992",
    fill: "white"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M21.332 18.5067L21.4271 18.2109L21.5733 18.2587",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3408 16.5547L22.2617 16.801L22.3835 16.8412",
    fill: "white"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3405 16.5547L22.4196 16.801L22.2979 16.8412",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5852 16.7344H22.3291V16.8638",
    fill: "white"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M22.585 16.7344L22.3779 16.8869L22.3027 16.7821",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0977 16.7344L22.3048 16.8869L22.3799 16.7821",
    fill: "white"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0977 16.7344H22.3538V16.8638",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4919 17.0236L22.4128 16.7773L22.291 16.8176",
    fill: "white"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4923 17.0228L22.2852 16.8703L22.3603 16.7656",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1914 17.0228L22.3986 16.8703L22.3234 16.7656",
    fill: "white"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1914 17.0236L22.2705 16.7773L22.3923 16.8176",
    fill: "white"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5117 15.9062L21.4326 16.1525L21.5544 16.1928",
    fill: "white"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5114 15.9062L21.5905 16.1525L21.4688 16.1928",
    fill: "white"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7561 16.0859H21.5V16.2154",
    fill: "white"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7559 16.0859L21.5488 16.2384L21.4736 16.1337",
    fill: "white"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2686 16.0859L21.4757 16.2384L21.5508 16.1337",
    fill: "white"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2686 16.0859H21.5247V16.2154",
    fill: "white"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6628 16.3752L21.5837 16.1289L21.4619 16.1692",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6632 16.3744L21.4561 16.2219L21.5312 16.1172",
    fill: "white"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3613 16.3744L21.5685 16.2219L21.4934 16.1172",
    fill: "white"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3613 16.3752L21.4404 16.1289L21.5622 16.1692",
    fill: "white"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7907 16.6094L20.7275 16.8062L20.8249 16.8384",
    fill: "white"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M20.791 16.6094L20.8542 16.8062L20.7568 16.8384",
    fill: "white"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9861 16.7539H20.7812V16.8575",
    fill: "white"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9857 16.7539L20.8201 16.8759L20.7598 16.7919",
    fill: "white"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5957 16.7539L20.7613 16.8759L20.8216 16.7919",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5957 16.7539H20.8006V16.8575",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9105 16.9819L20.8473 16.7852L20.75 16.8174",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9107 16.9833L20.7451 16.8614L20.8054 16.7773",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6699 16.9833L20.8355 16.8614L20.7752 16.7773",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6699 16.9819L20.7331 16.7852L20.8304 16.8174",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1514 17.168L21.1064 17.3089L21.1759 17.332",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1514 17.168L21.1964 17.3089L21.127 17.332",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2898 17.2695H21.1436V17.3438",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2896 17.2695L21.1712 17.3564L21.1279 17.2966",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0117 17.2695L21.1301 17.3564L21.1733 17.2966",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0117 17.2695H21.158V17.3438",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2374 17.4339L21.1925 17.293L21.123 17.316",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2375 17.4358L21.1191 17.3489L21.1624 17.2891",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 17.4358L21.1838 17.3489L21.1406 17.2891",
    fill: "white"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0654 17.4339L21.1104 17.293L21.1798 17.316",
    fill: "white"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6582 19.625L23.5791 19.8713L23.7009 19.9115",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6579 19.625L23.737 19.8713L23.6152 19.9115",
    fill: "white"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9026 19.8047H23.6465V19.9342",
    fill: "white"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9024 19.8047L23.6952 19.9572L23.6201 19.8524",
    fill: "white"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M23.415 19.8047L23.6222 19.9572L23.6973 19.8524",
    fill: "white"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23.415 19.8047H23.6711V19.9342",
    fill: "white"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8093 20.0939L23.7302 19.8477L23.6084 19.8879",
    fill: "white"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8097 20.0931L23.6025 19.9407L23.6777 19.8359",
    fill: "white"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5088 20.0931L23.7159 19.9407L23.6408 19.8359",
    fill: "white"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5088 20.0939L23.5879 19.8477L23.7097 19.8879",
    fill: "white"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2731 19.0352L24.21 19.2319L24.3073 19.2642",
    fill: "white"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2734 19.0352L24.3366 19.2319L24.2393 19.2642",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4686 19.1797H24.2637V19.2833",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4681 19.1797L24.3025 19.3017L24.2422 19.2177",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0781 19.1797L24.2437 19.3017L24.3041 19.2177",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0781 19.1797H24.283V19.2833",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3929 19.4077L24.3297 19.2109L24.2324 19.2432",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3931 19.4091L24.2275 19.2871L24.2879 19.2031",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1523 19.4091L24.318 19.2871L24.2576 19.2031",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1523 19.4077L24.2155 19.2109L24.3128 19.2432",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0934 18.8555L23.0303 19.0523L23.1276 19.0845",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0937 18.8555L23.1569 19.0523L23.0596 19.0845",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2889 19H23.084V19.1036",
    fill: "white"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2884 19L23.1228 19.122L23.0625 19.038",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8984 19L23.064 19.122L23.1244 19.038",
    fill: "white"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8984 19H23.1033V19.1036",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2132 19.228L23.1501 19.0312L23.0527 19.0635",
    fill: "white"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2135 19.2294L23.0479 19.1074L23.1082 19.0234",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9727 19.2294L23.1383 19.1074L23.0779 19.0234",
    fill: "white"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9727 19.228L23.0358 19.0312L23.1331 19.0635",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6341 18.5352L18.5391 18.8309L18.6853 18.8787",
    fill: "white"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6342 18.5352L18.7293 18.8309L18.583 18.8787",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9265 18.75H18.6191V18.9054",
    fill: "white"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9261 18.75L18.6774 18.9324L18.5869 18.807",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3418 18.75L18.5905 18.9324L18.681 18.807",
    fill: "white"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3418 18.75H18.6491V18.9054",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8155 19.0965L18.7205 18.8008L18.5742 18.8485",
    fill: "white"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8151 19.0969L18.5664 18.9145L18.6569 18.7891",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4531 19.0969L18.7018 18.9145L18.6113 18.7891",
    fill: "white"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4531 19.0965L18.5482 18.8008L18.6944 18.8485",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5123 20.5664L21.4805 20.6648L21.5294 20.6809",
    fill: "white"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5122 20.5664L21.5441 20.6648L21.4951 20.6809",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6093 20.6367H21.5068V20.6885",
    fill: "white"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6093 20.6367L21.5263 20.6977L21.4961 20.6557",
    fill: "white"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M21.415 20.6367L21.4981 20.6977L21.5283 20.6557",
    fill: "white"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M21.415 20.6367H21.5175V20.6885",
    fill: "white"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M21.572 20.7546L21.5402 20.6562L21.4912 20.6724",
    fill: "white"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5723 20.7553L21.4893 20.6943L21.5194 20.6523",
    fill: "white"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4521 20.7553L21.5352 20.6943L21.5051 20.6523",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4521 20.7546L21.484 20.6562L21.533 20.6724",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3833_12983"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 29,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrazilFlag);
export default __webpack_public_path__ + "static/media/brazilFlag.0eaf0e3622f2936c841c4e687ac36779.svg";
export { ForwardRef as ReactComponent };